<div class="position-relative" >
    <div (click)="openPatientCallPopup()" class="d-flex align-items-center img-radius justify-content-center wid-40 hei-40 p-2 bg-primary position-fixed cursor-pointer" style="right:10px;bottom:5px;z-index:1010;">
      <i class="fa fa-solid fa-phone f-20 text-white"></i>
    </div>
</div>